exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui-fluid .ui-inputtext {\n    font-size: 1em;\n    margin-top: -7px;\n    margin-left: -6px;\n    margin-bottom: -7px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-detail/cui-detail.component.css
// module id = ../../../../../src/app/shared/cui-detail/cui-detail.component.css
// module chunks = main